import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Tooltip } from '@mui/material';
import useHandleTrackEvent from 'hooks/useHandleTrackEvent';

const NavItem = ({ title, href, startIcon, action }) => {
  const theme = useTheme();
  const history = useHistory();
  const { pathname } = useLocation();
  const dashboardSidebarExpanded = useSelector(
    (state) => state.uiStates.dashboardSidebarExpanded,
  );
  const handleTrackEvent = useHandleTrackEvent();

  return (
    <Box mr={2}>
      <Tooltip
        title={dashboardSidebarExpanded ? '' : title}
        arrow
        placement="top"
      >
        <Box
          data-trackid={`open_${title}_bottombar`}
          sx={{
            padding: '8px 8px',
            textAlign: 'center',
            background:
              pathname === href
                ? theme.palette.background.level1
                : 'transparent',
            borderTop:
              pathname === href
                ? `2px solid ${theme.palette.primary.light}`
                : 'none',
            // marginBottom: 1,
            cursor: 'pointer',
            ':hover': {
              background: theme.palette.background.level1,
            },
            display: 'flex',
            alignItems: 'center',
            borderRadius: '50%',
          }}
          onClick={(e) => {
            handleTrackEvent(e, `open_${title}_bottombar`);
            if (href) {
              history.push(href);
            } else {
              action();
            }
          }}
        >
          {typeof startIcon === 'string' ? (
            <img
              src={startIcon}
              alt=""
              style={{
                filter: pathname === href ? 'none' : 'invert(0.5)',
                width: 20,
                height: 20,
              }}
            />
          ) : (
            startIcon
          )}
          {dashboardSidebarExpanded ? (
            <Typography
              sx={{
                color:
                  pathname === href
                    ? theme.palette.text.primary
                    : theme.palette.text.secondary,
                fontWeight: pathname === href ? 600 : 500,
                marginLeft: 1,
                display: 'flex',
              }}
            >
              {title}
            </Typography>
          ) : null}
        </Box>
      </Tooltip>
    </Box>
  );
};

NavItem.propTypes = {
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  href: PropTypes.string,
  startIcon: PropTypes.any,
  onClose: PropTypes.func,
  action: PropTypes.func,
};

export default NavItem;
